/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import constantes from "../../../catalogos/constantes";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";
import FormTime from "../../../shared/forms/FormFields/FormTime";
import FormClipboardImage from "../../../shared/forms/FormFields/FormClipboardImage";
import useApiIncidencia from "../../../api/administracion/useApiIncidencia";
import FormRadioButtonList from "../../../shared/forms/FormFields/FormRadioButtonList";
import FormAutocomplete from "../../../shared/forms/FormFields/FormAutocomplete";
import UltimosServicios from "./UltimosServicios";
import alerts from "../../../shared/alerts";
import PrioridadTemplate from "../PrioridadTemplate";
import FormCheckBox from "../../../shared/forms/FormFields/FormCheckBox";

const General = ({value, onChange, onValidate, puedeEditar, gestorGuardadoId, errors,submitted}) => {
    const api = useApiIncidencia();

    const [unidadId, setUnidadId] = useState(null)
    const infoRequerida = Number(value?.puestoId) === constantes.puestos.operador;
   
    const handleCartaPorte = async (values, onParentChange) => {
        if (values?.cartaPorte === null) {
            onParentChange(values);
            return;
        }

        if (values?.cartaPorte < 1000) {
            onParentChange(values);
            return;
        }

        const result = await api.obtenerViaje(values?.cartaPorte);
        const operadorId = result?.operadorId;
        const unidadId = result?.unidadId;
        const cajaId = result?.cajaId;
        const gestorOperacionesId = result?.gestorOperacionesId;
        const coordinadorId = result?.coordinadorId;
        const empresaId = result?.empresaId;
        const tipoEmpleadoId = result?.tipoEmpleadoId;

        onParentChange({...values, operadorId, unidadId, cajaId, coordinadorId, empresaId, tipoEmpleadoId, gestorOperacionesId});
    };

    const onHideServicios = ()=>{
        setUnidadId(null)
    }

    const mostrarServicios = (unidadId) => {
        if ((unidadId??0) === 0) {
            alerts.aviso('Debe seleccionar la unidad')
            return
        }

        setUnidadId(unidadId)
    }

    return (
        <>
            <Form columns={4} values={value} onChange={onChange}  onValidate={onValidate} submitted={submitted}
                  formDisabled={(value?.id > 0 && value?.estatus !== constantes.estatusIncidencias.Creada) || !puedeEditar}>

                <Field label={'Folio'} field={'folio'} render={FormTextBox} disabled={true} cols={2}/>

                <Field label={'Carta Porte (Opcional)'} field={'cartaPorte'} cols={2}
                       render={({onParentChange, parent, ...props}) =>
                           <FormInputNumber {...props} min={1}
                                            useGrouping={false}
                                            onChange={(cartaPorte) => handleCartaPorte({
                                                ...parent, cartaPorte
                                            }, onParentChange)}/>}/>

                <Field label={"Prioridad"} field={"prioridadId"} source="general/PrioridadIncidencia"
                       render={FormDropDown}
                       itemTemplate={PrioridadTemplate}
                       required={true} cols={2}/>
                <Field field={'operadorId'} label={'Empleado'} cols={2}
                       render={({onParentChange, parent, ...props}) => <FormDropDown {...props}  required={true}
                                                                                     source="empleados"
                                                                                     params={{                                                                                      
                                                                                         todasLasEmpresas: true
                                                                                     }}
                                                                                     onChange={(operadorId, item) => onParentChange({
                                                                                         operadorId,
                                                                                         coordinadorId: item?.jefeId,
                                                                                         tipoEmpleadoId: item?.tipoEmpleadoId,
                                                                                         puestoId : item?.puestoId,
                                                                                         gestorOperacionesId: item?.gestorOperacionesId
                                                                                     })}/>
                       }
                />
                
               <Field field={'puestoId'} label={'Puesto'} source="puestos" disabled
                       render={FormDropDown}
                       params={{puestoIds: [constantes.puestosDeTrafico], todasLasEmpresas: true}} cols={2}/>
                 <Field field={'coordinadorId'} label={'Coordinador  (Opcional)'} source="empleados"
                       render={FormDropDown}
                       params={{puestoIds: [constantes.puestosDeTrafico], todasLasEmpresas: true}} cols={2}/>
              <Field field={'gestorOperacionesId'} label={'Gestor Operaciones'} source="empleados"
                       render={FormDropDown}
                       params={{
                           id: gestorGuardadoId,
                           puestoIds: [constantes.puestos.gestorOperadores],
                           todasLasEmpresas: true
                       }} cols={2}/>
                <Field label={"Unidad de Negocio"} field={"unidadDeNegocioId"} source="unidadesNegocio"
                       render={FormDropDown}
                       required={infoRequerida}
                       error={infoRequerida}
                       className={infoRequerida && submitted ? "p-invalid" : ""}
                       cols={2}/>

                <Field label={"Departamento"} field={"departamentoId"} source={"departamentosIncidencia"}
                       render={FormDropDown}
                       required={true} cols={2}/>

                <Field label={"Ubicación"} field={"ubicacionId"} source={"patios"} render={FormDropDown}
                       required={true} cols={2}/>              
               
                <Field field={"tipoEmpleadoId"} label={"Tipo de Operación"} source={"tiposEmpleadoIncidencia"}
                       render={FormDropDown}
                       required={true} disabled={value?.id > 0} cols={2}/>

                <Field field={'unidadId'} linkLabel={'Unidad'} source="unidades" render={FormDropDown}     
                     required={infoRequerida}
                     error={infoRequerida}
                     className={infoRequerida && submitted ? "p-invalid" : ""}
                     onClickLabel={()=>mostrarServicios(value?.unidadId)}
                     params={{todasLasEmpresas: true}}/>

                <Field field={'cajaId'} label={'Caja  (Opcional)'} source="unidadesCajas" render={FormDropDown}
                       params={{id: constantes.tiposEquipo.arrastre, todasLasEmpresas: true}}/>

                <Field label={'Lugar y Evento'} field={'lugarEvento'} render={FormTextBox}  required={infoRequerida}
                     error={infoRequerida}
                     className={infoRequerida && submitted ? "p-invalid" : ""} cols={2}/>

                <Field field={'tipoId'} label={'Tipo de Incidencia'} cols={2}
                       render={({onParentChange, parent, ...props}) => <FormDropDown {...props} required={true}
                                                                                     source="tipoIncidencias"
                                                                                     params={{departamentoId: parent?.departamentoId}}/>
                       }
                       required={true}/>

                <Field field={'subTipoId'} label={'SubTipo de Incidencia'} cols={2}
                       render={({onParentChange, parent, ...props}) => <FormDropDown {...props} required={true}
                                                                                     source="subTipoIncidencias"
                                                                                     params={{tipoId: parent?.tipoId}}/>
                       }
                />

                <Field label={'¿Viaje Siniestrado?'} field={'viajeSiniestrado'} cols={2}
                       render={({...props}) => <FormCheckBox {...props} cols={2}/>}/>

                <Field label={'Descripción'} field={'descripcion'} cols={4}
                       render={({...props}) => <FormTextArea {...props}  rows={8} required={true}  error={errors?.descripcion}/>}/>

                <Field
                    field="seUsoGrua"
                    label="¿Se Usó Grua?"
                    options={constantes.siNoOptions}
                    render={FormRadioButtonList}  required={true}
                    cols={2} error={errors?.seUsoGrua}
                />

                <Field
                    field="tieneReporteAseguradora"
                    label="Tiene Reporte Aseguradora"
                    options={constantes.siNoOptions}
                    render={FormRadioButtonList}  required={true}
                    cols={2} error={errors?.tieneReporteAseguradora}
                />

                {value.tieneReporteAseguradora &&
                    <Field
                        label="Reporte Aseguradora"
                        field="reporteAseguradora"
                        render={FormTextBox}
                        cols={2}
                        errors={errors} required
                    />
                }

                <Field field={'EstadoUnidadId'} label={'Estado Unidad (Opcional)'} source="incidenciaEstadoEvento"
                       render={FormDropDown} cols={2}/>

                <Field field={'responsableAfectadoId'} label={'Responsable / Afectado (Opcional)'}
                       source="responsableAfectado"
                       render={FormRadioButtonList} cols={2}/>

                <Field field={'paisId'} label={'Pais'} source="paises" render={FormDropDown}  
                     required={infoRequerida}
                     error={infoRequerida}
                     className={infoRequerida && submitted ? "p-invalid" : ""}
                     cols={2}/>

                <Field field={'estadoId'} label={'Estado'} source="estados" cols={2}
                       render={({onParentChange, parent, ...props}) => (
                           <FormDropDown source="subTipoIncidencias" params={{id: parent?.paisId}}
                                            required={infoRequerida}
                     error={infoRequerida}
                     className={infoRequerida && submitted ? "p-invalid" : ""} {...props} />)}/>

                <Field field={'municipioId'} label={'Municipio'} source="municipios" cols={2}
                       render={({onParentChange, parent, ...props}) => (
                           <FormDropDown source="subTipoIncidencias" params={{id: parent?.estadoId}}  required={infoRequerida}
                     error={infoRequerida}
                     className={infoRequerida && submitted ? "p-invalid" : ""} {...props} />)}/>

                <Field field={"atendio"} label={"Atendio"} required={true} cols={2}
                       render={({onParentChange, parent, ...props}) =>
                           <FormAutocomplete source="empleados"
                                             params={{operadores: false, todasLasEmpresas: true}} {...props} />}/>

                <Field label={'Fecha Incidencia'} field={'fechaIncidencia'} render={FormCalendar} required={true}
                       cols={2}/>

                <Field label={'Hora Incidencia'} field={'horaIncidencia'} render={FormTime} required={true} cols={2}/>

                {value.departamentoId === constantes.departamento.MonitoreoSeguridad &&
                    <Field label={'Longitud'} field={'longitud'} maxFractionDigits={10} cols={2}
                           render={({...props}) => <FormInputNumber {...props}  error={errors?.longitud} required/>}/>
                }

                {value.departamentoId  === constantes.departamento.MonitoreoSeguridad &&
                    <Field label={'Latitud'} field={'latitud'} maxFractionDigits={10} cols={2} required={true}
                           render={({...props}) => <FormInputNumber {...props}/>}/>
                }

                <Field label={'Evidencia'} field={'evidencia'} render={FormClipboardImage} required={false} cols={2}/>

                <Field label={'Cobro'} field={'cobro'} cols={2} disabled={value?.estatus !== constantes.estatusIncidencias.PendienteCobro}
                       render={({...props}) => <FormCheckBox {...props} cols={2}/>}/>

            </Form>

            <UltimosServicios unidadId={unidadId} onHide={onHideServicios} />
        </>
    );
};


export default General;
